import { CSSProperties, useEffect, useRef, useState } from "react";
import { getInitials } from "../../utils";
import { Icons } from "../../utils/iconPath";
import "./style.css";

interface ProfilePhotoProps {
  photo?: string;
  name?: string;
  containerStyle?: CSSProperties;
  nameStyle?: CSSProperties;
  size?: string | number;
  onClick?: (event?: React.MouseEvent<HTMLDivElement>) => void;
  customInitials?: string;
}
export const ProfilePhoto = ({
  photo,
  name,
  containerStyle,
  size = "4rem",
  onClick,
  customInitials,
  nameStyle,
}: ProfilePhotoProps) => {
  const containerRef = useRef<HTMLDivElement | null>(null);

  const [containerWidth, setContainerWidth] = useState(20);

  useEffect(() => {
    if (size && containerRef.current && containerRef.current.clientWidth) {
      setContainerWidth(containerRef.current.clientWidth / 2);
    }
  }, [size, containerRef, containerRef.current?.clientWidth]);

  return (
    <div
      className={`profilePhoto unselectable ${
        onClick ? "clickable profilePhotoClickable" : ""
      }`}
      style={{
        backgroundColor: !photo && name ? "rgba(var(--off-white))" : "",
        height: size,
        maxHeight: size,
        minHeight: size,
        width: size,
        maxWidth: size,
        minWidth: size,
        ...containerStyle,
      }}
      onClick={onClick}
      ref={containerRef}
      title={name}
    >
      {photo ? <img src={photo} className="photo" alt="profile" /> : null}

      {!photo && !name ? (
        <img
          src={Icons?.DEFAULT_PROFILE}
          className="photo"
          alt="default profile"
        />
      ) : null}

      {!photo && name ? (
        <p
          className="name"
          style={{
            fontSize: `${containerWidth}px`,
            lineHeight: "125%",
            ...nameStyle,
          }}
        >
          {customInitials ? customInitials : getInitials(name)}
        </p>
      ) : null}
    </div>
  );
};
